import { BREAKPOINT_MEDIUM_PX } from '@/settings';

/**
 * Determines if the current window width is less than the medium breakpoint.
 *
 * This function checks the width of the window and returns a boolean indicating
 * whether the window width is considered to be in the mobile range, based on a predefined
 * medium breakpoint value.
 *
 * @returns A boolean indicating if the window width is less than the medium breakpoint.
 */
export const isMobile = () => {
  const windowWidth = window.innerWidth;

  return windowWidth < BREAKPOINT_MEDIUM_PX;
};
